import { render, staticRenderFns } from "./WidgetDisplayTypePicker.vue?vue&type=template&id=ef5e26da&scoped=true"
import script from "./WidgetDisplayTypePicker.vue?vue&type=script&lang=js"
export * from "./WidgetDisplayTypePicker.vue?vue&type=script&lang=js"
import style0 from "./WidgetDisplayTypePicker.vue?vue&type=style&index=0&id=ef5e26da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5e26da",
  null
  
)

export default component.exports